"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Theme = require("../Theme");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var getThumbStyles = function getThumbStyles(theme) {
  return {
    borderWidth: 1,
    borderColor: theme.mode === _Theme.ThemeMode.light ? theme.colors.baseContrast020 : "transparent",
    background: "white",
    height: theme.spacing.base * 2.5,
    width: theme.spacing.base * 2.5
  };
};
var Slider = {
  styles: function styles(theme) {
    return {
      root: {
        gap: theme.spacing.base,
        "& button": {
          "& svg": {
            height: theme.spacing.base * 2,
            width: theme.spacing.base * 2
          }
        },
        "&::-moz-range-thumb": {
          backgroundColor: theme.colors.baseContrast070
        }
      },
      progress: {
        height: theme.spacing.base,
        borderRadius: theme.spacing.base,
        overflow: "hidden",
        "&::-webkit-progress-bar": {
          background: theme.colors.baseContrast020
        },
        background: theme.colors.baseContrast020 // firefox
      },
      input: {
        "&::-webkit-slider-thumb": _objectSpread({
          marginTop: -8
        }, getThumbStyles(theme)),
        "&::-moz-range-thumb": _objectSpread({}, getThumbStyles(theme))
      }
    };
  }
};
var _default = exports.default = Slider;